import React from 'react';
import PropTypes from 'prop-types';

import ContrastContext from '../context/contrastContext';
import Hero from '../components/Hero';
import Section from '../components/Section';
import { MarkdownContent } from '../components/Content';

const GenericPage = ({
  title,
  heroImage,
  heroContent,
  pageContent,
}) => {
  return (
    <>
      <Hero image={heroImage} />

      <Section colorScheme="black">
        <div className="container flex flex-col md:flex-row py-12 gap-x-12 text-base">
          <div className="pb-4 md:w-1/3">
            <h2>
              <span className="bg-theme-underline">{title}</span>
            </h2>
          </div>
          <div className="md:w-2/3 text-base">
            <MarkdownContent content={heroContent} />
          </div>
        </div>
      </Section>

      <Section colorScheme="white">
        <div class="container py-12">
          <div class="content text-base xl:px-36 2xl:px-64">
            <MarkdownContent content={pageContent} />
          </div>
        </div>
      </Section>
    </>
  );
};

GenericPage.propTypes = {
  title: PropTypes.string.isRequired,
  heroImage: PropTypes.object.isRequired,
  heroContent: PropTypes.string.isRequired,
  pageContent: PropTypes.string.isRequired,
};

export default GenericPage;
